import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import PicturesUpload from "@components/PicturesUpload/PicturesUpload";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import Loader from "@components/Loader/Loader";
import styled from "@emotion/styled";
import StyledDrawer from "@components/StyledDrawer";
import TextIconButton from "@components/TextIconButton";
import BackupOutlinedIcon from "@mui/icons-material/BackupOutlined";

const Buttons = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`;

const PicturesUploadDrawer: FC<{ onClose: () => void; open: boolean }> = ({
  onClose,
  open,
}) => {
  const { t } = useTranslation();
  const patient = useSelector((state: RootState) => state.home.selectedPatient);

  return (
    <StyledDrawer onClose={onClose} open={open} width="600px">
      {patient ? (
        <PicturesUpload
          patient={patient}
          buttons={({ save, isDone, isSubmitting }) => {
            return (
              <Buttons>
                <TextIconButton
                  disabled={isSubmitting || isDone}
                  onClick={save}
                  variant="contained"
                  size="large"
                  text={t(`photos.uploadDialog.uploadButton`)}
                  icon={BackupOutlinedIcon}
                />
              </Buttons>
            );
          }}
        />
      ) : (
        <Loader />
      )}
    </StyledDrawer>
  );
};

export default PicturesUploadDrawer;
